import React, { useEffect } from "react";
import { FormControlLabel, Checkbox } from "@material-ui/core";
import { useInput } from "react-admin";

export default function RaCheckBoxInput(props) {
	const { input: { value, onChange } } = useInput(props);
    const { source, label, style, controlProps, onChangeProps, defaultValue } = props;

    const toggle = event => {
        if(onChangeProps)
            onChangeProps(event.target.checked);
        onChange(event.target.checked);
    };

    useEffect(() => {
        onChange(defaultValue);
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

	return (
		<FormControlLabel
            control={<Checkbox checked={value} {...controlProps} />}
            label={label ? label : source}
            onChange={toggle}
            style={style}
            defaultValue={defaultValue}
        />
	);
};